module.exports = __webpack_public_path__ + "img/gamesdk9.d6b6197.png";